import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useEffect } from "react";

const STORAGE_KEY = "profinda_custom_configuration";
const CUSTOMIZE_CONFIG_COMMAND = "window.PF.Initializers.customizeConfig()";

export const useNotifyAboutCustomConfig = () => {
  const { showGrowl } = useGrowlStoreActions();

  useEffect(() => {
    const customConfig = storage.getItem(STORAGE_KEY);

    if (!customConfig) {
      return;
    }

    if (window.PF.config.environment === "puppetmaster") {
      showGrowl({
        title: "Custom configuration content is enabled",
        message: `In order to disable it call \`${CUSTOMIZE_CONFIG_COMMAND}\``,
        kind: "alert"
      });
    } else if (customConfig.locale) {
      showGrowl({
        title: "Custom locale configuration is enabled",
        message: `In order to disable it call \`${CUSTOMIZE_CONFIG_COMMAND}\``,
        kind: "alert"
      });
    }
  }, []);
};
